import { createReducer } from '@reduxjs/toolkit';

import { electronActions } from './electron.actions';

const initialState: ElectronState = {
  connected: false,
};

type ElectronState = {
  /** Whether or not electron is connected. */
  connected: boolean;
};

export const electronReducer = createReducer(initialState, (builder) =>
  builder.addCase(electronActions.connected, (state, action) => {
    state.connected = action.payload.connected;
  }),
);
